/** * * Asynchronously loads the component for
UpdatePaymentMethod
* */ import { lazyLoad } from "utils/loadable";
export const UpdatePaymentMethod = lazyLoad(
  () => import("./index"),
  (module) => module.UpdatePaymentMethod
);
